const common = {
    'common.sure': 'Confirmer',
    'common.save': 'Sauvegarder',
    'common.cancel': 'Annuler',
    'common.loading': 'Chargement...',
    'common.loading.noMore': 'Pas plus~',
    'common.loading.loading1': 'Chargement',
    'common.success': 'Succès',
    'common.fail': 'Echec',
    'common.unKnowError': 'Anomalie inconnue',
    'common.unitDayOdd': 'Jour',
    'common.unitDayPlural': 'Jours',
    'common.unitMonthOdd': 'Mois',
    'common.unitMonthPlural': 'Mois',
    'common.infiniteAct': 'Première fois sans limite !',
    'common.label': 'Promotions à venir',
    'common.404': 'Oups. La page que vous avez demandée n\'a pas été trouvée!'
}
const language = {
    'lang.chinese': 'Chinois',
    'lang.english': 'Anglais',
    'lang.germany': 'Allemand',
    'lang.spanish': 'Espagnol',
    'lang.french': 'Français',
    'lang.italian': 'Italien',
    'lang.portuguese': 'Portugais',
}
// 登录页
const login = {
    'login.loginText': 'Se connecter',
    'login.input.email': 'Email(LenovoID)',
    'login.input.password': 'Mot de passe',
    'login.tip.noAccount': 'Pas encore de compte ?',
    'login.tip.toRegister': 'Aller à S’inscrire',
    'login.tip.forget': 'Mot de passe oublié?',
    'login.check.noInfo': 'Erreur d\'émail ou de mot de passe',
    'login.failed': 'Echec de se connecter',
    'login.terms': 'Veuillez consulter les termes et conditions',
    'login.banner.flow': 'Inscrivez - vous maintenant et profitez de 1GB * 6 mois de données gratuites',
    'login.banner.VFflow': 'Inscrivez - vous maintenant et profitez de 5GB * 3 mois de données gratuites',
    'login.banner.coming': 'Promotions à venir:',
    'login.banner.size': 'Données illimitées pour le premier mois'
}
// 注册页面
const register = {
    'register.registerText': 'S’inscrire',
    'register.input.firstName': 'First Name',
    'register.check.noFirstNameField': 'Please input First Name',
    'register.input.lastName': 'Last Name',
    'register.check.noLastNameField': 'Please input Last Name',
    'register.input.email': 'Email',
    'register.input.imgCode': 'Captcha d‘image',
    'register.input.verifyCode': 'Code de vérification',
    'register.input.password': 'Mot de passe',
    'register.input.rePassword': 'Confirmer le mot de passe',
    'register.input.alRegister': 'Déjà enregistré',
    'register.input.toLogin': 'aller à Se connecter',
    'register.input.termsOfService': 'conditions d\'utilisation',
    'register.input.privacyStatement': 'déclaration de confidentialité',
    'register.tip': 'En créant un compte, vous acceptez les {termsOfService} et la {privacyStatement}.',
    'register.tipForTablet': 'En créant le compte, vous avez lu et accepté les <a1>Descriptions du Plan de données préchargées</a1>, <a2>les termes et Conditions</a2> par Lenovo Connect, <a3> les termes et Conditions</a3> par HUE, <a4>la politique de protection de la vie privée</a4> par Lenovo Connect, et <a5>la politique de protection de la vie privée</a5> par HUE.',
    'register.sendMsg.text': 'Obtenir le code de vérification',
    'register.sendMsg.reSend': 'Envoyer à nouveau',
    'register.sendMsg.sendSuccess': 'Envoyé avec succès',
    'register.sendMsg.sendFailed': 'Echoué à envoyer',
    'register.check.noEmailField': 'Veuillez saisir votre email',
    'register.check.noImageCodeField': 'Veuillez saisir le code de vérification de l\'image',
    'register.check.noVerifyField': 'Veuillez saisir le code de vérification de l\'e-mail',
    'register.check.noPasswdField': 'Veuillez entrer le mot de passe',
    'register.check.noConfirmPasswd': 'Veuillez confirmer votre mot de passe',
    'register.check.errorEmail': 'Erreur d\'émail',
    'register.check.errorImageCode': 'Erreur de captcha d\'image',
    'register.check.errorVerifyCode': 'Erreur de code de vérification',
    'register.check.errorPasswd': 'Erreur de mot de passe',
    'register.check.errorTwoPasswd': 'Mot de passe inconsistant',
    'register.success': 'Inscrit avec succès',
}
// 首页
const home = {
    'home.header.upload': 'Mettre en line',
    'home.header.iccid': 'Code ICCID',
    'home.flowUse.title': 'Forfait de Données Actuel',
    'home.flowUse.status.title': 'Etat d\'Utilisation',
    'home.flowUse.status.used': 'Utilisé',
    'home.flowUse.status.remaining': 'Restant',
    'home.flowUse.dataPlan.key': 'Nom du Forfait de Données',
    'home.flowUse.validity.key': 'Validité',
    'home.flowUse.note.key': 'Note',
    'home.flowUse.note': 'Une fois que l\'allocation de données est atteinte dans le cycle actuel, la connexion cessera jusqu\'au cycle suivant.',
    'home.flowUse.leftDay': '{day} {unit} restant (s)',
    'home.flowUse.currentDataPlan.title': 'Mon (Mes) Forfait (s) de Données',
    'home.flowUse.currentDataPlan.titleHue': 'Forfait de services Ma connectivité',
    'home.flowUse.outDate': 'Le forfait de données a expiré.',
    'home.flowUse.lock': 'La carte SIM est verrouillée.',
    'home.flowUse.noDataPlan': 'Données inutilisées',
    'home.flowUse.status.unlimited': 'Illimité',
    'home.area.intro.title': 'Recharger',
    'home.area.intro.titleHue': 'Aufladen',
    'home.area.intro.content': 'Nos forfaits peuvent couvrir tous les pays de <cta>l\'UE</cta> (Autriche, Belgique, Bulgarie, Croatie, Chypre, République Tchèque, Danemark, Estonie, Finlande, France, Allemagne, Grèce, Hongrie, Irlande, Italie, Lettonie, Lituanie, Luxembourg, Malte, Pays-Bas, Pologne, Portugal, Roumanie, Slovaquie, Slovénie, Espagne et Suède), <cta>plus Islande, Norvège, Suisse, Royaume-Uni et Etats-Unis d\'Amérique,</cta>.',
    'home.area.intro.contentHUE': 'Nos forfaits peuvent couvrir tous les pays de <cta>l\'UE</cta> (Autriche, Belgique, Bulgarie, Croatie, Chypre, République Tchèque, Danemark, Estonie, Finlande, France, Allemagne, Grèce, Hongrie, Irlande, Italie, Lettonie, Lituanie, Luxembourg, Malte, Pays-Bas, Pologne, Portugal, Roumanie, Slovaquie, Slovénie, Espagne et Suède), <cta>plus Islande, Norvège, Suisse, Royaume-Uni,</cta>Veuillez activer à la fois les données mobiles et litinérance (pas de frais ditinérance supplémentaires).',
    'home.area.intro.vatIntro': 'Les prix incluent la TVA si applicable.',
    'home.area.intro.suggest': 'Suggérer',
    'home.area.switch.title': 'Région:',
    'home.active.title': 'Activer Mon Forfait de Données',
    'home.active.intro': 'Le forfait de données de précharge "{packageContent}" doit être activé dans les 90 jours suivant l\'achat de la Carte SIM Lenovo Connect. Une validité de {timeLength} suit immédiatement l\'activation.',
    'home.active.agree': 'Oui, j\'ai lu et accepté la Description du Forfait de <a>Données de Précharge</a>, les <a1>Conditions Générales</a1> et la <a2>Politique de Confidentialité</a2>. Lenovo Connect Alimenté par Truphone.',
    'home.active.agreeForTablet': 'Oui, j\'ai lu et accepté la Description du Forfait de <a>Données de Précharge</a>, les <a1>Conditions Générales</a1> et la <a2>Politique de Confidentialité</a2>.',
    'home.active.btnText': 'Activer Maintenant',
    'home.active.failed': 'Echoué à activer!',
    'home.active.success': 'Activé avec succès',
    'home.active.success.btn': 'Compris',
    'home.active.detail.title': 'Description du Forfait de Données',
    'home.active.detail.faq': 'Si vous avez toutes questions, veuillez consulter le <a>Service Client</a>.',
}
const suggest = {
    'suggest.title': 'Boîte à suggestion',
    'suggest.toast': 'Veuillez entrer du contenu',
    'suggest.success': 'Couronné de succès',
    'suggest.suggestions': "S'il vous plaît partagez vos suggestions ou questions avec nous",
    'suggest.submit': 'Soumettre',
    'suggest.information': 'Informations',
    'suggest.submission': 'Ma soumission',
    'suggest.noMore': 'Plus de données',
    'suggest.uploadImg': "La taille de l'image ne doit pas dépasser 5 m",
}
// 我的页面
const me = {
    'me.signOut': 'Se déconnecter',
    'me.nav.device': 'Appareils)',
    'me.nav.package': 'Forfait (s) de Données',
    'me.nav.order': 'Commande(s)',
    'me.nav.accountInfo': 'Compte',
    'me.nav.FAQ': 'FAQ',
    'me.nav.contactUs': 'Nous Contacter',
    'me.signOut.alert.title': 'Se déconnecter',
    'me.signOut.alert.content': 'Etes-vous sûr que vous voulez vous déconnecter?'
}
// 套餐卡片
const packageCard = {
    'package.validDate': 'Validité {timeLength} {dateUnit}',
    'package.validTo': 'Valable jusqu\'au {date} UTC',
    'package.orderBtnText': 'Commander',
    'package.extend.title': 'Forfait de Données de Prolonger',
    'package.expand.title': 'Forfait de Données d\'Etendre',
    'package.extend.titleHue': 'Souscrivez à un forfait mensuel de services de connectivité',
    'package.expand.titleHue': 'Ajouter un forfait de services de connectivité supplémentaire',
    'package.expand.add': 'Ajouter',
}
// 套餐详情
const packageDetail = {
    'packageDetail.privacy': 'Oui, j\'ai lu et accepté les <a>Conditions Générales</a> et la <b>Politique de Confidentialité</b>.',
    'packageDetail.privacyForTablet': 'Oui, j\'ai lu et accepté les <a>Conditions Générales</a> et la <b>Politique de Confidentialité</b>.',
    'packageDetail.description': 'Description du Forfait de Données',
    'packageDetail.expansionPackage.title': 'Etendre le Forfait de Données Actuel',
    'packageDetail.payBtn.text': 'Payer Maintenant',
}
// 地址
const billAddress = {
    'billAddress.history.title': 'Adresse de Facturation Historique',
    'billAddress.fieldWrap.title': 'Entrer Votre Adresse de Facturation',
    'billAddress.btn.continue': 'Continuer',
    'billAddress.btn.cancel': 'Annuler',
    'billAddress.field.firstName': 'Prénom(s)',
    'billAddress.tips.payment': 'Comment payer',
    'billAddress.tips.newCard': 'Nouvelle carte',
    'billAddress.tips.oldCard': 'Vieilles cartes',
    'billAddress.field.lastName': 'Nom de famille',
    'billAddress.field.email': 'Email',
    'billAddress.field.street': 'Rue',
    'billAddress.field.city': 'Ville',
    'billAddress.field.state': 'Etat',
    'billAddress.field.postCode': 'Code postal',
    'billAddress.field.country': 'Pays',
    'billAddress.field.firstNameError': 'Le champ de prénom (s) ne peut pas être vide',
    'billAddress.field.lastNameError': 'Le champ de nom de famille ne peut pas être vide',
    'billAddress.field.emailError': 'Le champ d\'émail ne peut pas être vide',
    'billAddress.field.emailFormatError': 'Erreur de format d\'e-mail',
    'billAddress.field.streetError': 'Le champ de rue ne peut pas être vide',
    'billAddress.field.cityError': 'Le champ de ville ne peut pas être vide',
    'billAddress.field.stateError': 'Le champ de province/état/comté ne peut pas être vide',
    'billAddress.field.postCodeError': 'Le champ de code postal ne peut pas être vide',
    'billAddress.field.countryError': '国家是必填字段',
}
// 订单
const order = {
    'order.subType.1': 'Activer',
    'order.subType.2': 'Commander',
    'order.subType.4': 'Echanger',
    'order.subType.5': 'Cadeau',
    'order.subType.6': 'Commande d\'entreprise',
    'order.subType.7': 'Essai',
    'order.subType.8': 'Mise à jour',
    'order.subType.9': 'Ajout',
    'order.subType.systemOrder': 'Commande de système',
    'order.item.orderNum': 'No. de Commande',
    'order.item.content': 'Détails',
    'order.item.orderType': 'Type de Commande',
    'order.item.validity': 'Validité',
    'order.item.subTotal': 'Sous-total',
    'order.item.vat': 'TVA',
    'order.item.totalFee': 'Total',
    'order.noInfo.message': 'Aucun forfait commandé encore!',
    'order.noInfo.btnText': 'Retour à la Une'
}
// 支付结果页
const payResult = {
    'pay.success': 'Succès de paiement',
    'pay.fail': 'Echec de paiement',
    'pay.checkOrder': 'Vérifier les Commandes',
    'pay.back': 'Retour',
    'pay.continue': 'Continuer à Commander',
}
// 我的设备页面
const device = {
    'device.switch': 'Changer d\'Appareil',
    'device.status.current': 'Appareil Actuel',
    'device.status.available': 'Appareil(s) Disponible(s)',
    'device.switch.alert.title': 'Changer d\'Appareil',
    'device.switch.alert.content': 'Etes-vous sûr de passer à cet appareil?',
    'device.noInfo.message': 'Aucun appareil lié',
    'device.noInfo.btnText': 'Mettre en ligne le Code ICCID',
    'device.edit.prompt.message': 'Entrer votre pseudonyme',
    'device.edit.check.none': 'Le pseudonyme ne peut pas être vide',
}
// 我的套餐
const myDataPlan = {
    'myDataPlan.tabbar.available': 'Disponibles',
    'myDataPlan.tabbar.expired': 'Expiré (s)',
    'myDataPlan.noAvailablePlan': 'Aucun forfait disponible maintenant',
    'myDataPlan.noExpiredPlan': 'Aucun forfait expiré maintenant',
}
// 账号信息
const accountInfo = {
    'account.errorNickname': 'La longueur du pseudonyme doit être de 4-20 caractères.',
    'account.account.fieldTitle': 'Compte',
    'account.nickName.fieldTitle': 'Pseudonyme',
    'account.nickName.character': '4-20 caractères comprenant lettres, chiffres ou symboles.',
}
// FAQ页面
const FAQ = {
    'faq.question.1': 'Puis-je passer des appels ou envoyer des SMS?',
    'faq.question.2': 'Comment puis-je acheter un forfait de données et vérifier mon enregistrement de commande?',
    'faq.question.3': 'Quelles sont les règles de commander les données?',
    'faq.question.4': 'Quels modes de paiement puis-je utiliser?',
    'faq.question.5': 'Comment puis-je couper mon forfait de données si je ne veux pas l\'utiliser?',
    'faq.question.6': 'J\'ai commandé avec succès un forfait de données , pourquoi ne puis-je pas l\'utiliser?',
    'faq.question.7': 'Que faire si je ne peux pas accéder à Internet?',
    'faq.question.8': 'Quels pays le forfait de données peut-il couvrir?',
    'faq.question.9': 'Comment puis-je joindre le Service Client Lenovo?',
    'faq.question.10': 'Comment puis-je demander un reçu pour ma commande?',
    'faq.question.11': 'Comment remplacer une carte SIM?',
    'faq.question.12': 'Est-il gratuit de remplacer une SIM?',
    'faq.question.13': 'Puis-je suspendre le forfait de données activé si ma SIM est perdue, cassée ou défectueuse?',
    'faq.question.14': 'Que faire si j\'ai oublié mon mot de passe?',
    'faq.question.15': 'Puis-je faire des changements après que l\'ICCID de ma carte SIM et mon ID Lenovo sont liés?',
    'faq.question.16': 'Que dois-je faire si l\'appareil me demande d\'entrer un code PIN, PIN 2 ou PUK, ou d\'entrer un APN?',
    'faq.question.17': 'Comment puis-je vérifier l\'ICCID de ma SIM?',
    'faq.question.18': 'Nous contacter',
    'faq.answer.1': 'La SIM supporte uniquement les données pour l\'accès au réseau. Vous ne recevrez pas de numéro de mobile. Vous pouvez encore passer des appels ou envoyer des SMS en utilisant des Apps comme Skype, WhatsApp.',
    'faq.answer.2': 'Veuillez visiter aoacwap.lenovoconnect.com pour procéder.',
    'faq.answer.3': 'Les forfaits de données commandés avec succès seront automatiquement activés (par exemple, Forfait d\'Etendre Mes Données) ou attendront dans la file d\'attente pour être activés (par exemple, Forfait de Prolonger Mes Données). Nous ne supportons pas le remboursement ou la suspension du forfait de données.',
    'faq.answer.4': 'Nous vendons des forfaits en GBP, EUR, USD, CHF, NOK, DKK,SEK et supportons les cartes de Crédit/Débit Visa ou Master.',
    'faq.answer.5': 'Si vous voulez arrêter d\'utiliser la connexion cellulaire, veuillez cliquer sur OFF les "Données mobiles". Veuillez noter que votre forfait de données en cours ne sera PAS suspendu ni remboursé.',
    'faq.answer.6.1': '1) Si le forfait commandé est de prolonger votre forfait actuel, il peut seulement être activé une fois que votre forfait actuel expire.',
    'faq.answer.6.2': '2) Si le forfait commandé est d\'étendre votre forfait actuel, il doit  être activé automatiquement. Veuillez consulter les autres FAQ pour les problèmes de connexion, ou contacter le Service Client Lenovo.com dans votre propre pays.',
    'faq.answer.6.3': '3) Si vous avez plusieurs appareils sous le même ID Lenovo, veuillez vous assurer que le forfait de données commandé est sous l\'ICCID de la SIM de l\'appareil utilisé actuel.',
    'faq.answer.7.1': '1) Vérifiez si les "Données mobiles" sont mis en ON.',
    'faq.answer.7.2': '2) Vérifiez si l\'"Itinérance des données" est activée. Allez dans Paramètres-> Réseau et Internet-> Réseau mobile-> Itinérance des données',
    'faq.answer.7.3': '3) Vérifiez si le Nom du Point d\'Accès (APN) est correctement configuré.Allez dans Paramètres-> Réseau et Internet-> Réseau mobile-> Avancé-> Noms des points d\'accès-> ajouter APN: net.truphone.com',
    'faq.answer.7.4': '4) Si ceci est votre première connexion, il pourrait prendre quelques minutes pour la SIM de se connecter.',
    'faq.answer.7.5': '5) Veuillez vous assurer que le forfait de données de précharge est activé; sinon, veuillez suivre les instructions dans le paquet SIM pour activer.',
    'faq.answer.7.6': '6) Assurez-vous que votre emplacement actuel est dans notre champ de couverture de service (Voir la liste complète des pays couverts ci-dessous) Déplacez votre appareil à côté d\'une fenêtre ou d\'une zone ouverte afin de recevoir un meilleur signal.',
    'faq.answer.8': 'Le forfait de données peut couvrir tous les pays de l\'UE (Autriche, Belgique, Bulgarie, Croatie, Chypre, République Tchèque, Danemark, Estonie, Finlande, France, Allemagne,      Grèce, Hongrie, Irlande, Italie, Lettonie, Lituanie, Luxembourg, Malte, Pays-Bas, Pologne, Portugal, Roumanie, République Slovaque, Slovénie, Espagne, Suède), plus Islande, Norvège,  Suisse, Royaume-Uni et Etats-Unis d\'Amérique.',
    'faq.answer.8.1': 'Le forfait de données peut couvrir tous les pays de l\'UE (Autriche, Belgique, Bulgarie, Croatie, Chypre, République Tchèque, Danemark, Estonie, Finlande, France, Allemagne,      Grèce, Hongrie, Irlande, Italie, Lettonie, Lituanie, Luxembourg, Malte, Pays-Bas, Pologne, Portugal, Roumanie, République Slovaque, Slovénie, Espagne, Suède), plus Islande, Norvège,  Suisse, Royaume-Uni.',
    'faq.answer.9': 'Veuillez consulter les informations de Nous Contacter de Lenovo.com dans votre propre pays.',
    'faq.answer.10': 'Le reçu sera envoyé à votre adresse émail enregistrée automatiquement après avoir commandé avec succès. Veuillez   vérifier à la fois votre boîte de réception et votre boîte de courrier indésirable pour lui. Si encore non reçu, veuillez contacter le Service Client Lenovo.',
    'faq.answer.11': 'Si votre SIM est cassée, perdue ou défectueuse, veuillez contacter le Service Client Lenovo pour une solution.',
    'faq.answer.12': 'Oui, mais des frais de service de coursiers peuvent s\'appliquer. Veuillez contacter le Service Client Lenovo pour les détails.',
    'faq.answer.13': 'Désolé, le forfait de données ne peut pas être suspendu.',
    'faq.answer.14': 'Vous pouvez ré-initialiser votre mot de passe via "Mot de passe oublié" sur la page Se connecter',
    'faq.answer.15': 'Oui. Veuillez contacter le Service Client Lenovo pour une telle demande. Après vérification, le personnel du Service Client vous aidera à supprimer la liaison actuelle entre l‘ICCID de la SIM et votre ID Lenovo. Notez que les forfaits de données dans les validités ne peuvent pas être suspendus ou remboursés quel que soit l’état de la liaison SIM-ID Lenovo.',
    'faq.answer.16': 'Essayez de désactiver et de réactiver les "Données mobiles" et   également de redémarrer l\'appareil. Si cela n\'aide pas, veuillez contacter notre Service Client. ',
    'faq.answer.17.1': '1) Vous pouvez trouver l\'ICCID sur la puce SIM ou le support SIM.',
    'faq.answer.17.2': '2) Si vous avez activé la SIM et le forfait de données de précharge, veuillez visiter aoacwap.lenovoconnect.com et vérifier "Moi" -> "Appareil"',
    'faq.answer.18': 'Veuillez consulter les informations de Nous Contacter de Lenovo.com dans votre propre pays.',
}
// 联系我们
const Contact = {
    'contact.chooseRegion.text': 'Choisir votre région',
    'contact.country.AT': 'Autriche',
    'contact.country.BE': 'Belgique',
    'contact.country.DK': 'Danemark',
    'contact.country.FI': 'Finlande',
    'contact.country.FR': 'France',
    'contact.country.DE': 'Allemagne',
    'contact.country.IE': 'Irlande',
    'contact.country.IT': 'Italie',
    'contact.country.LUX': 'Luxembourg',
    'contact.country.NL': 'Pays-Bas',
    'contact.country.NO': 'Norvège',
    'contact.country.PT': 'Portugal',
    'contact.country.ES': 'Espagne',
    'contact.country.SE': 'Suède',
    'contact.country.CH': 'Suisse',
    'contact.country.UK': 'Royaume-Uni',
    'contact.country.USA': 'USA',

    'contact.phone.AT': '(+43) (0)1 9287 666',
    'contact.phone.BE': '02-700-73-77 (tarif local)',
    'contact.phone.DK': '+45 89881536',
    'contact.phone.FI': '+358 97 47 90 251',
    'contact.phone.FR': '+ 33 170 381 927',
    'contact.phone.DE': '(+49) (0)201 22099 888',
    'contact.phone.IE': '1-890-928-860 (Les appels vers ce numéro sont facturés au tarif local depuis une ligne fixe et ont un coût minimum de 0,05 €. Les appels depuis les mobiles peuvent varier.)',
    'contact.phone.IT': '(+39)02 303 10000',
    'contact.phone.LUX': '+352 2487 16 11',
    'contact.phone.NL': '+31 204 990 153',
    'contact.phone.NO': '+47 67 204501',
    'contact.phone.PT': '+351 211 227 833',
    'contact.phone.ES': '+34 9179 11 799',
    'contact.phone.SE': '+46 840 30 01 81',
    'contact.phone.CH': '+41 44 798 2222',
    'contact.phone.UK': '+44 333-777-3991 (Tarif National)',
    'contact.phone.USA': '1-800-426-7378, #1',

    'contact.workHours.AT': '9:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.BE': '9:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.DK': '9:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.FI': '9:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.FR': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.DE': '8 - 18 Uhr Lundi - Vendredi',
    'contact.workHours.IE': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.IT': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.LUX': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.NL': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.NO': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.PT': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.ES': 'de 8:00h  à 18:00h, du lundi au vendredi',
    'contact.workHours.SE': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.CH': '9:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.UK': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.USA': '00:00 - 24:00 Lundi - Dimanche',
}
// 绑卡页面
const bindSim = {
    'bindSim.hello': 'Bonjour',
    'bindSim.activate.title': 'Activer Votre Forfait de Données',
    'bindSim.tip.text1': 'Mette en ligne l\'image du code-barres pour identifier la carte SIM',
    'bindSim.tip.text2': 'Activer et utiliser le forfait de données',
    'bindSim.btn.text': 'Mette en ligne l\'image',
}
//平板fap
const faqApp = {
    'faq.title.1': 'FAQ-About Lenovo Connect',
    'faq.question.1': 'Q1: How do I reach Lenovo Customer Service if the following answers cannot solve my question? ',
    'faq.answer.1': 'A1: Please refer to below Customer Service information on Lenovo.com in your own country. Or directly send an email to: service@lenovoconnect.com. Please include the ICCID of the SIM in the email.',
    'faq.question.2': 'Q2: Can I make calls or send SMS?',
    'faq.answer.2': 'A2: The SIM only supports data for network. You will not receive a mobile number. It does not support voice or SMS.',
    'faq.question.3': 'Q3: Can the SIM be switched to other devices?',
    'faq.answer.3': 'A3: The SIM only can be used in the tablet. Cannot be switched to other devices.',
    'faq.question.4': 'Q4: What countries can the data plan cover? Will there be extra roaming fee?',
    'faq.answer.4': 'A4: The data plan covers all EU countries (Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden), plus Iceland, Norway, Switzerland, and United Kingdom. There is no extra roaming fee within these places.',
    'faq.title.2': 'FAQ-About Connectivity Service Package',
    'faq.question.5': 'Q1: How can I buy a service package and check my order record? Can the unused data roll into the next 30 days?',
    'faq.answer.5': 'A1: Please visit the app "Len" preloaded on the tablet. Or visit aoacwap.lenovoconnect.com to check the data usage. If the current package is not used up, it cannot be rolled into the next 30 days.',
    'faq.question.6': 'Q2: When does the gift package start to count?',
    'faq.answer.6': 'A2: The gift package starts after the register and log in to the APP "Len", and activate the preload package on the homepage.',
    'faq.question.7': 'Q3: What are the rules of ordering connectivity service package?',
    'faq.answer.7': 'A3: Service package ordered successfully will be automatically activated (e.g. Subscribe To A Monthly Connectivity Service Package) or will wait in queue to be activated after the current service was exhausted (e.g. Add An Extra Connectivity Service Package). Service package does not support refund or suspension.',
    'faq.question.8': 'Q4: What payment methods can I use?',
    'faq.answer.8': 'A4: We support Credit/Debit Visa or Master cards in GBP, EUR, USD,CHF, NOK, DKK, SEK.',
    'faq.question.9': "Q5: I have successfully ordered the service package, why can't I use it?",
    'faq.answer.9': 'A5: If it is to add an extra connectivity service package, it can only be activated once your current package expires. If it is to subscribe to a monthly connectivity service package, it should be activated automatically. Please refer to other FAQs for connectivity issue, or contact Lenovo Customer Service or email: service@lenovoconnect.com.',
    'faq.title.3': 'FAQ-About APP Len',
    'faq.question.10': 'Q1: What if I cannot find the APP or the APP was deleted by mistake?',
    'faq.answer.10': `A1: Please visit Tablet Center to re-download the APP. Or visit the link to re-download: https://aoacupg.lenovoconnect.com/common/downloadLatest`,
    'faq.question.11': "Q2: What should I do if I can't log in to the APP?",
    'faq.answer.11.1': 'A2: 1. It may take a longer time to log in to the APP for the first time. Please wait for about half a minute.',
    'faq.answer.11.2': '2. Please try to exit the APP completely and then re-enter.',
    'faq.answer.11.3': '3. If the APP registration page shows: This email has existed. Please log in directly with your previous Lenovo ID or register with a new email address.',
    'faq.answer.11.4': '4. If the APP login page shows: Card has bound by other accounts. In this case, you have already bound this card to an email account. To unbind and reset your email, please contact the customer service team or email service@lenovoconnect.com',
    'faq.question.12': 'Q3: What if I forgot my password of the registered email?',
    'faq.answer.12': 'A3: You can re-set your password via "Forgot password" on the Sign in page of the APP.',
    'faq.title.4': 'FAQ-About using data',
    'faq.question.13': "Q1: How should I turn off my connectivity package if I don't want to use it?",
    'faq.answer.13': 'A1：If you want to stop using cellular connectivity, please click OFF the "Mobile data". Please note that your ongoing package will NOT be suspended or refunded.',
    'faq.question.14': 'Q2：What if I cannot get Internet access?',
    'faq.answer.14.1': 'A2：1. Please check that "Settings--Network&Internet--Mobile data”is turned on.',
    'faq.answer.14.2': '2. Please check that "Settings--Network&Internet--Data roaming”is turned on (need to be turned on, there will be no additional roaming charges).ƒ',
    'faq.answer.14.3': '3. Check the "Settings-Network&Internet-Advanced-Access Point Names" are set correctly, it should be set to: lenovo.m2m.drei.at (Please add manually if there is not)',
    'faq.answer.14.4': '4. If this is your first time to connect, it may take a few minutes.',
    'faq.answer.14.5': '5. Please log in to the APP Len and confirm that the free data package has been activated. If it is not activated, please log in to the APP and click "Activation" on the main page.',
    'faq.answer.14.6': '6. Please confirm that your region is within the scope of service (please refer to the following countries for details). You can move to a more open place to receive the signal. (Covering all EU countries Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden, plus Iceland, Norway, Switzerland, and United Kingdom).',
    'faq.answer.14.7': '7. Please check whether the SIM card is installed correctly and restart the device.',
    'faq.answer.14.8': '8. Please check Settings-Network&Internet-Choose network, you can manually select the network among them. If "forbidden" is displayed after a network is found, please click and clear "forbidden" manually. If there is no forbidden displayed, you may change the SIM into your phone, acting the same process to see available networks.',
    'faq.question.15': "Q3: How do I check my SIM's ICCID?",
    'faq.answer.15.1': 'A3:  1. Please pull out the SIM card inserted in the tablet, the ICCID is on the card.',
    'faq.answer.15.2': '2. Please visit App Len-Me-Device',
    'faq.answer.15.3': '3. Please visit aoacwap.lenovoconnect.com and you will see your ICCID on the page.',
    'faq.question.16': 'Q4: How do I request a receipt for my order?',
    'faq.answer.16.1': 'A4: The receipt will be sent to your registered email address automatically after ordering successfully. Please do check both your inbox and junk mail box for it. If still cannot find it, please contact Lenovo Customer Service or email: service@lenovoconnect.com',
    'faq.title.5': 'FAQ-About SIM Card',
    'faq.question.17': "Q1: Can I make changes after my SIM card's ICCID and my Lenovo ID are bound?",
    'faq.answer.17': 'A1: Yes. Please contact Lenovo Customer Service or email: service@lenovoconnect.com for the unbinding request. Please note that connectivity service package within validity cannot be suspended or refunded regardless of the SIM-Lenovo ID binding status.',
    'faq.question.18': 'Q2: What should I do if the card surface is damaged or lost? Can an activated service package be suspended?',
    'faq.answer.18': 'A2: If your SIM is broken or lost or faulty, please contact Lenovo Customer Service or email: service@lenovoconnect.com. We will arrange a new delivery after the confirmation of the detailed situation. The activated package cannot be suspended or refunded.',
}
// 接口返回错误码
const iCode = {
    'iCode.i0001': 'mauvais mot de passe',
    'iCode.i0002': 'Ce nom d\'utilisateur existe déjà',
    'iCode.i0003': 'Erreur de format de mot de passe',
    'iCode.i0004': 'Le compte doit être activé avant la connexion.',
    'iCode.i0005': 'Le compte est handicapé',
    'iCode.i0006': 'Délai d‘expiration de connexion',
    'iCode.i0007': 'Erreur',
    'iCode.i0008': '账号或密码错误',
    'iCode.i0009': 'Veuillez entrer le code de vérification graphique à 5 chiffres',
    'iCode.i0010': 'L’opération est trop fréquente. Veuillez essayer à nouveau plus tard.',
    'iCode.i0011': 'Adresse de rappel invalide.',
    'iCode.i0012': 'Signature invalide.',
    'iCode.i0013': 'Veuillez rafraîchir le code de vérification',
    'iCode.i0014': 'Erreur de serveur.',
    'iCode.i0015': 'L\'ID Good  de service est vide',
    'iCode.i0016': 'Message envoyé avec succès',
    'iCode.i0017': 'Envoi de message échoué',
    'iCode.i0018': '兑换码错误',
    'iCode.i0019': '请在兑换期内使用',
    'iCode.i0020': '兑换码已过期',
    'iCode.i0021': '兑换码已使用',
    'iCode.i0022': '兑换码已失效',
    'iCode.i0023': 'La commande est en train d\'être créée, veuillez attendre…',
    'iCode.i0024': 'Opération échouée',
    'iCode.i0025': '号卡不满足兑换条件',
    'iCode.i0026': 'Génération du code QR échouée',
    'iCode.i0027': '创建升级订单信息有误',
    'iCode.i0028': 'La SIM n\'existe pas',
    'iCode.i0029': '手机号格式错误',
    'iCode.i0030': '短信发送太频繁',
    'iCode.i0031': 'Erreur de paramètre',
    'iCode.i0032': 'Le nombre d\'envois de code de vérification dans la journée a atteint la limite supérieure',
    'iCode.i0033': '注册成功',
    'iCode.i0034': 'Enregistrement du compte échoué',
    'iCode.i0035': 'Veuillez lier l‘ICCID SIM d\'abord',
    'iCode.i0036': 'Veuillez vous connecter au compte d\'abord',
    'iCode.i0037': 'Mise à jour de l\'état échouée',
    'iCode.i0038': '启用中， 请稍后',
    'iCode.i0039': 'L\'ID de commande est vide',
    'iCode.i0040': 'Activation en cours, veuillez attendre',
    'iCode.i0041': 'Le forfait est hors de l\'étagère',
    'iCode.i0042': 'Activation échouée !',
    'iCode.i0043': 'Activation réussie !',
    'iCode.i0044': 'Le système ne peut pas identifier la SIM',
    'iCode.i0045': 'Forfait activé, ne pas répéter',
    'iCode.i0046': 'Aucun forfait activé',
    'iCode.i0047': 'SIM discontinuée',
    'iCode.i0048': 'Information du forfait incorrecte',
    'iCode.i0049': 'L\'utilisateur ou le mot de passe est vide',
    'iCode.i0050': 'Aucun forfait de base pour le mois',
    'iCode.i0051': 'Connexion réussie',
    'iCode.i0052': 'Connexion anormale',
    'iCode.i0053': 'L\'appareil est vide',
    'iCode.i0054': 'Erreur de code de vérification, veuillez ré-entrer',
    'iCode.i0055': 'Opération réussie',
    'iCode.i0056': 'La SIM est vide',
    'iCode.i0057': 'Echoué à obtenir le jeton',
    'iCode.i0058': '企业编码不存在',
    'iCode.i0059': 'L\'utilisation de la SIM est inconsistante avec les propriétés de l\'entreprise',
    'iCode.i0060': 'Veuillez ne pas opérer fréquemment',
    'iCode.i0061': '领取优惠券成功',
    'iCode.i0062': '不满足领取条件',
    'iCode.i0063': '领取优惠券出错',
    'iCode.i0064': 'Liaison Iccid échouée',
    'iCode.i0065': 'La carte est déjà liée à un autre compte',
    'iCode.i0066': 'Liaison réussie',
    'iCode.i0067': 'Erreur de liaison',
    'iCode.i0068': 'L\'ID SIM est vide',
    'iCode.i0069': 'esimId为空',
    'iCode.i0070': 'Aucune liaison SIM',
    'iCode.i0071': 'L\'utilisateur n\'existe pas',
    'iCode.i0072': 'Le pseudonyme ne peut pas être vide',
    'iCode.i0073': 'Mise à jour réussie',
    'iCode.i0074': 'Mise à jour échouée',
    'iCode.i0075': 'Page d\'accueil aucune SIM requête de forfait anormale',
    'iCode.i0076': 'Information pertinente non disponible',
    'iCode.i0077': 'Echoué à générer une signature cryptée.',
    'iCode.i0078': 'Commutation échouée',
    'iCode.i0079': 'Commutation réussie',
    'iCode.i0080': 'Veuillez ne pas soumettre de demandes à répétition !',
    'iCode.i0081': 'Veuillez rafraîchir et essayez à nouveau !',
    'iCode.i0082': 'Echoué à obtenir le graphique de bannière de la page d\'accueil',
    'iCode.i0083': 'Actuellement aucun ICCID lié, aucun forfait préférentiel',
    'iCode.i0084': 'Actuellement aucun ICCID lié, aucun forfait disponible',
    'iCode.i0085': '认证成功',
    'iCode.i0086': '认证失败',
    'iCode.i0087': 'Exception de système',
    'iCode.i0088': '卡已实名',
    'iCode.i0089': 'Le forfait est commandé avec succès',
    'iCode.i0090': 'Commande du forfait échouée',
    'iCode.i0091': '服务商品不存在',
    'iCode.i0092': '升级服务订单生成完毕',
    'iCode.i0093': '无升级套餐服务',
    'iCode.i0094': 'Aucune commande correspondante trouvée',
    'iCode.i0095': 'Le forfait actuel n’est pas payé',
    'iCode.i0096': 'L\'ID de forfait est vide dans la commande',
    'iCode.i0097': '套餐已启用',
    'iCode.i0098': 'Commande réussie',
    'iCode.i0099': '暂无码号可用',
    'iCode.i0100': '无该地区码号',
    'iCode.i0104': 'Impossible d\'obtenir la sous-région de la carte sim',
    'iCode.i0109': 'Echoué à lire le code-barres, veuillez essayer à nouveau.',
}
export default {
    ...common,
    ...language,
    ...login,
    ...home,
    ...packageDetail,
    ...register,
    ...packageCard,
    ...billAddress,
    ...me,
    ...accountInfo,
    ...order,
    ...device,
    ...myDataPlan,
    ...FAQ,
    ...iCode,
    ...payResult,
    ...Contact,
    ...bindSim,
    ...suggest,
    ...faqApp,
    'tab.text.home': 'Accueil',
    'tab.text.me': 'Mien'
}
